import "./style.less";

import { WeekOptionsModel } from "./model"; // not in use

import SearchPeriodsFixedController from "./controller";
import searchPeriodsFixedComponents from "./components/module";
// import SearchFactory from "./factory";
import SearchFixedService from "./service";

const modul = angular
    .module("searchPeriodsFixed", [searchPeriodsFixedComponents])

    .constant("WeekOptionsModel", WeekOptionsModel)

    .controller("SearchPeriodsFixedController", SearchPeriodsFixedController)

    .service("SearchFixedService", SearchFixedService);
// .factory("searchUrl", searchUrl);

export default modul.name;
